module.exports = __webpack_public_path__ + "assets/img/service-module2-2.d05cda0c.jpg";